import React from "react";

// reactstrap components
import {
  Button,
  Label,
  FormGroup,
  Input,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components
import ExamplesNavbar from "components/Navbars/ExamplesNavbar.js";

import DemoFooter from "components/Footers/DemoFooter.js";

const AboutUs = () => {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.classList.add("landing-page");
    return function cleanup() {
      document.body.classList.remove("landing-page");
    };
  });

  return (
    <>
      <div className="about-us section" >
        <div
          style={{
            //backgroundImage: "url(" + require("assets/img/bg.png") + ")",
            backgroundColor:"#3E3C3D",
            
          }}
          className="page-bg"
        >
          <ExamplesNavbar notHome={true} />
          {/* <div className="section about-us"> */}
          <Container>
            <Row>
            <Col
                lg={12}
                style={{
                  backgroundImage:
                    "url(" + require("assets/img/newaboutus/about4.jpg") + ")",
                    width: undefined,
                    height: undefined,
                    aspectRatio: 1
                }}
                className="about-image"
              />
              <Col lg={6} >
                <br></br>
                <h2 className="title text-white ">About Us  <hr style={{color:"#000000"}}/></h2>
                
                
                <div className="detail text-white">
                
                Meraj Housing society is a project owned by the Directors of Virk Group of Industries
                which has developed its name in the filed of manufacturing and customer service since 1995. 
                This housing project is the dream of the owners to provide the residents with a modern
                state of the art society in line with international standards thus adding value to the
                identity of our beloved city, Sialkot 
                </div>
              </Col>
            </Row>

            <Row className="my-5" >
              <Col
                lg={6}
                style={{
                  backgroundImage:
                    "url(" + require("assets/img/newaboutus/about2.jpg") + ")",
                }}
                className="about-image"
              />
              <Col lg={6} >
              <h3 className="title  text-white">
              <br/> Location <hr/></h3>
                 
                <div className="detail text-white">
                We understand the need for an upgraded contemporary society but yet affordable at the 
                same time for our people . Located at the most ideal location of our district, 
                Meraj housing will stand out from the rest because of its modern infrastructure 
                and world class facilitates 
                </div>
              </Col>
            </Row>

            <Row className="my-6" >
            <Col
                lg={6}
                style={{
                  backgroundImage:
                    "url(" + require("assets/img/newaboutus/about3.jpg") + ")",
                    backgroundColor:"#3E3C3D"
                }}
                className="about-image"
              />
              <Col lg={6}>
                <div className="detail text-white" >
                  <h3><br/>Minimalist design <hr/></h3>
                  The infrastructure for our society is meticulously planned by renowned architects 
                  and designers inspired by the modern minimalist trend, highlighting sleek and clean 
                  exteriors in a clean and green environment. Our careful planning’s are further lead 
                  by skilled professionals working tirelessly to visualize the dream of the developers
                  to provide our residents true value for their money and enriching their lifestyle.


                </div>
              </Col>
              
            </Row>

            <Row className="my-5">
              <Col
                lg={6}
                style={{
                  backgroundImage:
                    "url(" + require("assets/img/newaboutus/about1.jpg") + ")",
                }}
                className="about-image"
              />
              <Col lg={6}>

                <div className="detail text-white" >
                <h2><br/>Standing out <hr/></h2>
                  Meraj housing will stand out from the rest<br/> because of its
                  modern infrastructure and <br/>world class facilitates in the most<br/>
                  accessible area of the district. Our society<br/> will have a big
                  impact in enhancing the<br/> structural value of our district and<br/>
                  enriching the lifestyle of our residents.
                  <br></br>
                  <hr style={{width: "1px",height: "100px" ,background: "white", float:"left"}}></hr>
                </div>

              </Col>
            </Row>
            
          </Container>
          {/* </div> */}
          <div
          className={"footer-logo-section content-center"}style={{backgroundColor:"#000000"}}
        >
          <img
            className="footer-image"
            src={require("assets/img/logo@2x.png")}
          />
          
        </div>
         
          { <DemoFooter/> }
        </div>
      </div>
    </>
  );
};

export default AboutUs;
